var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconUnmatched(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_1307)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 27.9259H15.4783",
    stroke: "#0068B5",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4102 36.895L17.1528 34.1653",
    stroke: "#0068B5",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9999 43.4619L34.2607 38.7278",
    stroke: "#0068B5",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.5893 36.895L38.8467 34.1653",
    stroke: "#0068B5",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9997 27.9259H40.5215",
    stroke: "#0068B5",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.5893 18.9569L38.8467 21.6866",
    stroke: "#0068B5",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 12.39L21.7391 17.1163",
    stroke: "#0068B5",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4102 18.9569L17.1528 21.6866",
    stroke: "#0068B5",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.291 25.7811L31.5371 13.4116L19.1875 31.9113L26.7084 30.8428L24.4623 43.2201L36.8118 24.7204L29.291 25.7811Z",
    stroke: "#0068B5",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_1307"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 32,
    fill: "white",
    transform: "translate(10 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUnmatched);
export default __webpack_public_path__ + "static/media/icon_unmatched.b0b58bdd3aa2546a964c8b74089d18b6.svg";
export { ForwardRef as ReactComponent };